module.exports = __webpack_public_path__ + "img/ico_support_speaker.d49755cb.svg";